<button
  pButton type="button"
  label="{{ 'Save' | translate }}"
  (click)="save.emit()"
  class="p-button-primary w-full"
  icon="{{isSaving?'pi pi-spinner pi-spin':''}}"
  [disabled]="isSaving || disabled"
>
</button>
